<template>
  <v-col cols="12">
    <v-card>
      <v-card-title class="text-h5"> Top Purchases as a % of Shares Outstanding </v-card-title>

      <v-card-text>
        <p class="font-italic">
          Restricted to Officers and Directors.
          <router-link to="/other/form4_search"> Search all transactions </router-link>
        </p>
        <p>Aggregated Purchases within specified timeframe.</p>

        <!-- Options -->
        <v-row mt-6 mb-4>
          <v-col cols="12" sm="6" md="4" lg="3" xl="2">
            <v-text-field
              v-model="criteria.minimum_percent_change"
              type="number"
              suffix="%"
              placeholder=" "
              label="Minimum % shares outstanding"
              hide-details
            />
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" xl="2">
            <v-select
              v-model="criteria.date_range"
              :items="tenFilterDates"
              item-title="text"
              label="Date range"
              hide-details
            />
          </v-col>
        </v-row>

        <!-- Table -->
        <v-data-table
          v-model:options="pagination"
          v-model:sort-by="pagination.sortBy"
          :headers="tableHeaders"
          :items="tableItems"
          :items-per-page-options="[10, 25, 50, 100]"
          :loading="loading"
          :no-data-text="loading ? 'Loading...' : 'No results found.'"
          must-sort
        >
          <template #item="{ item }">
            <tr>
              <td>
                <v-btn
                  :class="{ 'mr-4': $vuetify.display.smAndUp }"
                  small
                  title="View Transactions"
                  class="ma-0"
                  @click="$refs.transactionDetailsDialog.showDetails(item, criteria)"
                >
                  View transactions
                </v-btn>
              </td>
              <td>{{ item.symbol }}</td>
              <td>{{ item.count }}</td>
              <td>{{ percent(item.percent_change_outstanding) }}</td>
              <td>{{ whole_number(item.transaction_shares) }}</td>
              <td>{{ currency(item.transaction_amount) }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <transaction-details-dialog ref="transactionDetailsDialog" />
  </v-col>
</template>

<script>
import { useUserStore, useAppStore, useWwStore } from '@/store'
// Modules
import api from '@/store/api'
import debounce from 'lodash/debounce'

// Mixins
import FormattersMixin from '@/mixins/formatters'

// Components
import TransactionDetailsDialog from '@/components/page/insider-dashboard/_TransactionDetailsDialog'

export default {
  components: {
    TransactionDetailsDialog
  },
  mixins: [FormattersMixin],

  data() {
    return {
      loading: false,
      tableHeaders: [
        { title: '', key: 'symbol', width: 1, sortable: false },
        { title: 'Ticker', key: 'symbol' },
        { title: 'Trans. Count', key: 'count' },
        { title: 'Percent Total Shares Outstanding', key: 'percent_change_outstanding' },
        { title: 'Total Shares', key: 'transaction_shares' },
        { title: 'Total Amount', key: 'transaction_amount' }
      ],
      tableItems: [],
      pagination: {
        sortBy: [{ key: 'percent_change_outstanding', order: 'desc' }],
        page: 1,
        itemsPerPage: 10
      },
      criteria: {
        transaction_type: 4,
        show_percent_change: true,
        date_range: 6,
        minimum_percent_change: 3
      },
      tenFilterDates: [
        { value: 0, text: 'Past Day' },
        { value: 1, text: 'Past 3 Days' },
        { value: 2, text: 'Past 7 Days' },
        { value: 6, text: 'Past 2 Weeks' },
        { value: 3, text: 'Past Month' },
        { value: 4, text: 'Past 3 Months' },
        { value: 5, text: 'Past 6 Months' },
        { value: 7, text: 'Past Year' }
      ]
    }
  },

  watch: {
    criteria: {
      deep: true,
      immediate: true,
      handler() {
        this.updateData()
      }
    }
  },

  methods: {
    updateData: debounce(function () {
      this.loading = true

      api
        .post('form4_agg_query', this.criteria)
        .then(response => {
          this.tableItems = response.data
        })
        .catch(error => {
          useAppStore().showNotification({
            type: 'error',
            text: (error.response && error.response.data) || error.message
          })
        })
        .then(() => (this.loading = false))
    }, 750)
  }
}
</script>
